import React from 'react';
import { RadioCardGroup } from '@printdeal/ui-library';
import { Image } from '@unpic/react';

import { OptionProps } from './types/FileDesignTypes';

interface Props {
  fieldName: string;
  option: OptionProps;
}

const DesignOptionRadio = ({
  fieldName,
  option,
}: Props) => (
  <RadioCardGroup.Field
    id={`${fieldName}-${option.title}`}
    label={option.title}
    value={option.title}
    image={(
      option.url && (
        <Image
          alt={option.title}
          aspectRatio={1}
          src={option.url}
          objectFit="cover"
          width={160}
        />
      )
    )}
  />
);

export default DesignOptionRadio;
